import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import CloseBtn from '../../../images/icons/close-modal.svg'
import {
  StyledCarrouselPopin,
  StyledCarrouselSlide,
  StyledCloseBtn,
  StyledContainer,
  StyledLargeCarousel,
} from './CarrouselPopin.styled'
import { CarouselVariantEnum } from '../../Carousel/Carousel'

const CarrouselPopin = (props) => {
  const { initialSlide, items, setIsPopinOpen } = props

  const [currentSlide, setCurrentSlide] = useState(initialSlide || 0)

  const slides = useMemo(
    () =>
      items.map((item, index) => (
        <StyledCarrouselSlide {...item.largeImage} key={item.title + index} />
      )),
    []
  )

  const title = items[currentSlide].title

  return (
    <StyledCarrouselPopin>
      <StyledContainer>
        <StyledCloseBtn onClick={() => setIsPopinOpen(false)}>
          <CloseBtn />
        </StyledCloseBtn>
        <StyledLargeCarousel
          initialSlide={initialSlide}
          onChange={setCurrentSlide}
          title={title}
          variant={CarouselVariantEnum.media}
        >
          {slides}
        </StyledLargeCarousel>
      </StyledContainer>
    </StyledCarrouselPopin>
  )
}

CarrouselPopin.propTypes = {
  initialSlide: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  setIsPopinOpen: PropTypes.func.isRequired,
}

export default CarrouselPopin
